"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityNurseBlockReason = void 0;
exports.instanceOfFacilityNurseBlockReason = instanceOfFacilityNurseBlockReason;
exports.FacilityNurseBlockReasonFromJSON = FacilityNurseBlockReasonFromJSON;
exports.FacilityNurseBlockReasonFromJSONTyped = FacilityNurseBlockReasonFromJSONTyped;
exports.FacilityNurseBlockReasonToJSON = FacilityNurseBlockReasonToJSON;
exports.FacilityNurseBlockReasonToJSONTyped = FacilityNurseBlockReasonToJSONTyped;
/**
 *
 * @export
 */
exports.FacilityNurseBlockReason = {
    CurrentEmployee: 'CURRENT_EMPLOYEE',
    NotEligibleForRehire: 'NOT_ELIGIBLE_FOR_REHIRE',
    Performance: 'PERFORMANCE',
    Compliance: 'COMPLIANCE',
    Attendance: 'ATTENDANCE'
};
function instanceOfFacilityNurseBlockReason(value) {
    for (const key in exports.FacilityNurseBlockReason) {
        if (Object.prototype.hasOwnProperty.call(exports.FacilityNurseBlockReason, key)) {
            if (exports.FacilityNurseBlockReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function FacilityNurseBlockReasonFromJSON(json) {
    return FacilityNurseBlockReasonFromJSONTyped(json, false);
}
function FacilityNurseBlockReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function FacilityNurseBlockReasonToJSON(value) {
    return value;
}
function FacilityNurseBlockReasonToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FacilityNurseBlockReason.js.map